import axiosInstance from "./api";

export const listFeedbacks = async ({
  page = 1,
  limit = 10,
  q = "",
  status = "",
  type = "",
  priority = "",
  area = "",
  category = "",
  roleFilter = "",
  startDate = "",
  endDate = "",
} = {}) => {
  const formattedStatus = Array.isArray(status) ? status.join(",") : status;
  return axiosInstance.get("feedbacks/main/getElms", {
    params: {
      page,
      limit,
      q,
      status: formattedStatus,
      type: type || category,
      priority,
      areaId: area,
      roleFilter,
      startDate,
      endDate,
    },
  });
};

export const createFeedback = async ({ data }) => {
  return axiosInstance.post("feedbacks/main/createElm", data);
};

export const updateFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/updateElm/${id}`, data);
};

export const deleteFeedback = async ({ id }) => {
  return axiosInstance.delete(`feedbacks/main/deleteElm/${id}`);
};

export const getFeedback = async ({ id }) => {
  return axiosInstance.get(`feedbacks/main/getElm/${id}`);
};

export const listEscalations = async ({
  page = 1,
  limit = 50,
  priority = "",
  area = "",
  startDate = "",
  endDate = "",
} = {}) => {
  return axiosInstance.get("feedbacks/main/escalations", {
    params: {
      page,
      limit,
      priority,
      areaId: area,
      startDate,
      endDate,
    },
  });
};

export const acceptFeedback = async ({ id, data = {} }) => {
  return axiosInstance.put(`feedbacks/main/accept/${id}`, data);
};

export const reassignFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/reassign/${id}`, data);
};

export const startProcessingFeedback = async ({ id }) => {
  return axiosInstance.put(`feedbacks/main/process/${id}`);
};

export const updateProgressFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/comment/${id}`, data);
};

export const respondFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/respond/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const resultUpdateFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/result/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const proposeChiefFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/propose-chief/${id}`, data);
};

export const collaborateFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/collaborate/${id}`, data);
};

export const reinforceFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/reinforce/${id}`, data);
};

export const acceptProposeFeedback = async ({ id }) => {
  return axiosInstance.put(`feedbacks/main/accept-propose/${id}`);
};

export const resolveWorkflowFeedback = async ({ id }) => {
  return axiosInstance.put(`feedbacks/main/resolve/${id}`);
};

export const changePriorityFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/change-priority/${id}`, data);
};

export const acceptCollaborationFeedback = async ({ id }) => {
  return axiosInstance.put(`feedbacks/main/accept-collaboration/${id}`);
};

export const forwardCollaborationFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/forward-collaboration/${id}`, data);
};

export const directiveFeedback = async ({ id, data }) => {
  return axiosInstance.put(`feedbacks/main/directive/${id}`, data);
};
